import { render, staticRenderFns } from "./NewInstanceModal.vue?vue&type=template&id=025b6d87&scoped=true"
import script from "./NewInstanceModal.vue?vue&type=script&lang=js"
export * from "./NewInstanceModal.vue?vue&type=script&lang=js"
import style0 from "./NewInstanceModal.vue?vue&type=style&index=0&id=025b6d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b6d87",
  null
  
)

export default component.exports